module.exports = __webpack_public_path__ + "img/Hypoxia-INCA_10X_IC.83c9f32c.png";